import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Tooltip } from '@efexteam/components';
import { Actions, Can, Subjects, useRole } from '@efexteam/permission-manager';
import { useTranslation } from 'react-i18next';
import { calculatorLaunch } from '../assets';
import useWalletsMixed from '../hooks/useWalletsMix';
import ConvertModal from '../pages/dashboard/components/wallets/ConvertModal';

const FloatingButtons = () => {
  const { t } = useTranslation();
  const { isPaymentAnalyst } = useRole();

  const [showConvertModal, setShowConvertModal] = useState(false);
  const dataMixed = useWalletsMixed();
  const location = useLocation();

  const relaunchTutorial = () => {
    setShowConvertModal(true);
  };

  return (
    <Can action={Actions.MANAGE} subject={Subjects.PAYMENTS}>
      <Tooltip
        title={t(
          isPaymentAnalyst ? 'walletConfigureConvert' : 'walletConvertHeader'
        )}
        placement="top"
      >
        <button
          onClick={relaunchTutorial}
          type="button"
          className={`rounded-full  bg-[#1A237E] w-[35px] h-[35px] p-0 z-[500] fixed right-[1rem] flex items-center justify-center ${
            location.pathname === '/dashboard'
              ? 'bottom-[4rem]'
              : 'bottom-[1rem]'
          }`}
        >
          <img
            src={calculatorLaunch}
            alt="launch tutorial"
            className="w-[15px] h-[25px]"
          />
        </button>
      </Tooltip>

      {showConvertModal && (
        <ConvertModal
          open={showConvertModal}
          wallets={dataMixed.walletsDataMixed}
          onClose={() => setShowConvertModal(false)}
          shouldReload={() => {
            setShowConvertModal(false);
          }}
        />
      )}
    </Can>
  );
};

export default FloatingButtons;
